import React, {useState} from "react";
import {Button, Card, Input, Checkbox, Form, Col, Row} from "antd";
import {addUserRole, editUserRole} from "../../../api";
import TextArea from "antd/es/input/TextArea";

function AddEditRoleDialog ({ action, role, onClose, setRoles}) {
    const [form] = Form.useForm();
    const [roleName, setRoleName] = useState(role?.roleName);
    const [roleOrder, setRoleOrder] = useState(role!==null ? role.orderId : 999);
    const [assignTask, setAssignTask] = useState(role!==null ? role.assignTasksFl : 'N');
    const [roleDisable, setRoleDisable] = useState(role!==null ? role.disableFlag : 'N');

    const onOrderChange = (e) => {
        const { value } = e.target;
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            setRoleOrder(Number(value));
        }
    }
    const onNameChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setRoleName(value);
        }
    }
    const onSubmit = async (values) => {
        if(action==='Add') {
            let newRole = {roleName: roleName, orderId: roleOrder, assignTasksFl: assignTask, excepApproverFl:'N', disableFlag: 'N'};
            let response = await addUserRole(newRole);
            if(response.status === 'SUCCESS')
                setRoles(response.data);
        }
        else
        {
            let editRole = {...role, roleName: roleName, orderId: roleOrder, assignTasksFl: assignTask, disableFlag: roleDisable};
            let response = await editUserRole(editRole);
            if(response.status === 'SUCCESS')
                setRoles(response.data);
        }
        onClose();
    }
    return (
        <div className='react-confirm-alert-body'>
            <h4>{action=='Add' ? 'Add New Role': ('Edit Role: '+roleName)}</h4>
            <section>
                <Form
                    form={form}
                    style={{ padding: '1rem 1rem' }}
                    onFinish={(values) => onSubmit(values)}
                >
                    <div style={{ top: 15, position: 'relative' }}>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Role Name'
                                    name='roleName'
                                    initialValue={roleName}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter role name!'
                                        }                                ]}
                                >
                                    <Col>
                                        <Input
                                            id='roleName'
                                            size='small'
                                            value={roleName}
                                            
                                            placeholder='Role Name'
                                            onChange={onNameChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Role Order'
                                    name='roleOrder'
                                    initialValue={roleOrder}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter role order!'
                                        }                                ]}
                                >
                                    <Col>
                                        <Input
                                            id='roleOrder'
                                            size='small'
                                            value={roleOrder}
                                            placeholder='Role Order'
                                            onChange={onOrderChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Assign Task?'
                                    name='assignTask'
                                    initialValue={assignTask==='Y'}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                >
                                    <Col>
                                        <Checkbox
                                            name='assignTask'
                                            checked={assignTask==='Y'}
                                            onChange={(e) => {
                                                let value = e.target.checked ? 'Y' : 'N';
                                                setAssignTask(value);
                                            }}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        {action === 'Edit' &&
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{alignItems: 'end'}}>
                                <Form.Item
                                    label='Disable?'
                                    name='role_disable'
                                    initialValue={roleDisable === 'Y'}
                                    labelCol={{span: 5}}
                                    style={{fontWeight: 'bolder'}}
                                >
                                    <Col>
                                        <Checkbox
                                            name='role_disable'
                                            checked={roleDisable === 'Y'}
                                            onChange={(e) => {
                                                let value = e.target.checked ? 'Y' : 'N';
                                                setRoleDisable(value);
                                            }}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        }
                    </div>
                    <div>
                        <Button
                            className='btn btn-primary start-5'
                            type='primary' htmlType='submit'
                        >
                            Save Changes
                        </Button>
                        <Button className='btn btn-primary start-5' type='primary' onClick={onClose}>
                            Cancel
                        </Button>{' '}
                    </div>
                </Form>
            </section>
        </div>
  )
}

export default AddEditRoleDialog;